export enum Collection {
  Announcements = 'announcements',
  Contacts = 'contacts',
  Donations = 'donations',
  News = 'news',
  Requests = 'requests',
  Reservations = 'reservations',
}
